'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = undefined;

var _serviceHelpers = require('./serviceHelpers');

var getFulfillers = exports.getFulfillers = function getFulfillers(accessToken, env) {
  return (0, _serviceHelpers.callFetch)('fulfillerIdentityUrl', 'GET', 'v1/fulfillers', null, accessToken, env).then(function (response) {
    return response.map(function (_ref) {
      var name = _ref.name,
          fulfillerId = _ref.fulfillerId,
          id = _ref.internalFulfillerId;
      return { name: name, id: id, fulfillerId: fulfillerId };
    });
  });
};
//# sourceMappingURL=fulfillerIdentity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/services/fulfillerIdentity.js
// module id = 564
// module chunks = 0